import { Check, MessageCircle } from "lucide-react";
import { useT } from "../../lib/i18n";
import { CATALOGUE } from "../../content/catalogue";
import { TeeIcon, CapIcon } from "../site/EntryIcons";

function Card({ item, on, onClick, testid, small }) {
  const { t } = useT();
  const Icon = item.offer === "accessoires" ? CapIcon : TeeIcon;
  return (
    <button type="button" onClick={onClick} aria-pressed={on} data-testid={testid}
      className={`group relative text-left overflow-hidden border transition-colors ${on ? "border-[#1C1917] ring-1 ring-[#1C1917]" : "border-[#E8E2D8] hover:border-[#1C1917]"} bg-[#F4F0EA]`}>
      <div className={`${small ? "aspect-[5/3]" : "aspect-[4/3]"} overflow-hidden`}>
        {item.photo
          ? <img src={item.photo} alt={item.label} loading="lazy" className="w-full h-full object-cover object-[center_28%] transition-transform duration-500 group-hover:scale-[1.04]" />
          : <div className="w-full h-full k-weave flex items-center justify-center"><Icon className="w-10 h-10 opacity-40" /></div>}
      </div>
      <div className="px-3 py-2.5 bg-[#FBF9F5]">
        <p className="text-sm font-semibold leading-tight">{t(item.label)}</p>
        {item.hint && !small && <p className="text-[11px] text-[#8C857B] mt-0.5 leading-snug">{t(item.hint)}</p>}
      </div>
      {on && <span className="absolute top-2 right-2 w-6 h-6 bg-[#1C1917] text-[#FBF9F5] flex items-center justify-center"><Check size={14} /></span>}
    </button>
  );
}

export function ProductPicker({ product, variant, onChange, wide = false }) {
  const { t } = useT();
  const sel = CATALOGUE.find((c) => c.key === product);
  const cols = wide ? "grid-cols-3 md:grid-cols-6" : "grid-cols-2 sm:grid-cols-3";
  return (
    <div className="grid gap-4">
      <div className={`grid ${cols} gap-2.5`} data-testid="product-grid">
        {CATALOGUE.map((c) => <Card key={c.key} item={c} on={product === c.key} testid={`express-product-${c.key}`} onClick={() => onChange(c.key, "")} />)}
      </div>
      <button type="button" onClick={() => onChange("conseil", "")} aria-pressed={product === "conseil"} data-testid="express-product-conseil"
        className={`inline-flex items-center gap-2 self-start px-4 py-2.5 text-sm border transition-colors ${product === "conseil" ? "bg-[#1C1917] text-[#FBF9F5] border-[#1C1917]" : "border-[#D6CEBF] hover:border-[#1C1917] bg-[#FBF9F5]"}`}>
        <MessageCircle size={15} /> {t("Je souhaite être conseillé")}
      </button>
      {sel?.variants.length > 0 && (
        <div data-testid="variant-row">
          <p className="k-eyebrow mb-2">{t("Quel modèle ?")} <span className="normal-case tracking-normal text-[#8C857B] font-normal">· {t("optionnel")}</span></p>
          <div className={`grid grid-cols-3 ${wide ? "md:grid-cols-6" : "sm:grid-cols-4"} gap-2.5`}>
            {sel.variants.map((v) => <Card key={v.key} item={{ ...v, offer: sel.offer }} small on={variant === v.key} testid={`express-variant-${v.key}`} onClick={() => onChange(sel.key, variant === v.key ? "" : v.key)} />)}
          </div>
        </div>
      )}
      <p className="text-xs text-[#8C857B]">{t("Les photos illustrent la catégorie : le modèle exact est recommandé dans le devis, selon votre usage et votre budget.")}</p>
    </div>
  );
}
